import script from "./cardInfoPedidos.vue?vue&type=script&setup=true&lang=js"
export * from "./cardInfoPedidos.vue?vue&type=script&setup=true&lang=js"

import "./cardInfoPedidos.vue?vue&type=style&index=0&id=83e36862&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83e36862"]])

export default __exports__